import { useState } from "react";
import UpDownIcon from "../icons/UpDown";

export default function SelectFilter({ label, values }) {
    const [openFilterIndex, setOpenFilterIndex] = useState([]);
    const [isAnimating, setIsAnimating] = useState(false);

    const toggleState = (index) => {
        setIsAnimating(true);

        setOpenFilterIndex((prevState) => {
            if (prevState.includes(index)) {
                return prevState.filter((i) => i !== index);
            } else {
                return [...prevState, index];
            }
        });
    };

    const handleAnimationEnd = () => {
        setIsAnimating(false);
    };

    const filterItems = [
        { label: "?????", values: ["?????", "?????", "?????", "?????", "?????"], qtd: ["?????", "?????", "?????", "?????", "?????"] },
        { label: "?????", values: ["?????", "?????", "?????", "?????", "?????"], qtd: ["?????", "?????", "?????", "?????", "?????"] },
        { label: "?????", values: ["?????", "?????", "?????", "?????", "?????"], qtd: ["?????", "?????", "?????", "?????", "?????"] },
        { label: "?????", values: ["?????", "?????", "?????", "?????", "?????"], qtd: ["?????", "?????", "?????", "?????", "?????"] },
        { label: "?????", values: ["?????", "?????", "?????", "?????", "?????"], qtd: ["?????", "?????", "?????", "?????", "?????"] },
        { label: "?????", values: ["?????", "?????", "?????", "?????", "?????"], qtd: ["?????", "?????", "?????", "?????", "?????"] },
        { label: "?????", values: ["?????", "?????", "?????", "?????", "?????"], qtd: ["?????", "?????", "?????", "?????", "?????"] },
        { label: "?????", values: ["?????", "?????", "?????", "?????", "?????"], qtd: ["?????", "?????", "?????", "?????", "?????"] }
    ];

    return (
        <div className="flex flex-col gap-[10px]">
            {filterItems.map((filter, index) => (
                <div key={index} className="relative cursor-pointer flex">
                    <div className="flex flex-col justify-center items-center bg-darker w-[300px] rounded-[12px] overflow-hidden text-2xl">
                        <p className="flex p-[12px] w-full md:justify-start justify-center h-[40px] items-center cursor-pointer select-none" onClick={() => toggleState(index)}>
                            {filter.label}
                        </p>
                        <div style={{ height: openFilterIndex.includes(index) ? `${filter.values.length * 40}px`: "0px", overflow: "hidden", transition: "height 0.4s ease-in-out",}}onTransitionEnd={handleAnimationEnd}>
                            {filter.values.map((value, i) => (
                                <div key={i} className="h-[40px] w-[300px] bg-[#C3A5B4]">
                                    <input type="checkbox" className="hidden" />
                                    <label className="flex justify-between mx-[15px] cursor-pointer select-none">
                                        <span className="mt-[3px]">{value}</span>
                                        <span className="mt-[3px]">{filter.qtd[i]}</span>
                                    </label>
                                </div>
                            ))}
                        </div>
                        <UpDownIcon className={`absolute bottom-[9px] right-[15px] select-none ${openFilterIndex.includes(index) ? "hidden" : " "}`}/>
                    </div>
                </div>
            ))}
        </div>
    );
}
